/** Two-letter initials of a name or company ("Brightside Bakery Ltd" -> "BB"); "?" for an empty one. */
export function initialsOf(name: string | null | undefined): string {
  const words = (name ?? '')
    .replace(/[^\p{L}\p{N}\s]/gu, ' ')
    .split(/\s+/)
    .filter(Boolean);
  if (words.length === 0) return '?';
  const letters = words.length === 1 ? words[0].slice(0, 2) : words[0][0] + words[1][0];
  return letters.toUpperCase();
}

// Tints (styles/_modern.scss, .avatar-0 to .avatar-5): the same name always gets the same colour.
const TINTS = 6;
function tintOf(name: string): number {
  let hash = 0;
  for (const char of name) hash = (hash * 31 + char.charCodeAt(0)) % 997;
  return hash % TINTS;
}

/** A round initials badge for a client or user. Decorative: the name next to it is what is read out. */
export function Avatar({ name, className = '' }: { name: string | null | undefined; className?: string }) {
  return (
    <span className={`avatar avatar-${tintOf(name ?? '')} ${className}`.trim()} aria-hidden="true">
      {initialsOf(name)}
    </span>
  );
}
